const BASE = '';

const getToken = () => localStorage.getItem('rz_token');
const getUser = () => JSON.parse(localStorage.getItem('rz_user') || 'null');

const headers = (extra = {}) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`,
  ...extra
});

export const api = {
  // Auth
  login: (email, password) =>
    fetch(`${BASE}/api/auth/login`, { method: 'POST', headers: headers(), body: JSON.stringify({ email, password }) }).then(r => r.json()),

  register: (data) =>
    fetch(`${BASE}/api/auth/register`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  // Vehicles
  getVehicles: () =>
    fetch(`${BASE}/api/vehicles`, { headers: headers() }).then(r => r.json()),

  getVehicle: (id) =>
    fetch(`${BASE}/api/vehicles/${id}`, { headers: headers() }).then(r => r.json()),

  decodeVin: (vin) =>
    fetch(`${BASE}/api/vehicles/vin/${vin}`, { headers: headers() }).then(r => r.json()),

  saveVehicle: (data) =>
    fetch(`${BASE}/api/vehicles`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  updateVehicle: (id, data) =>
    fetch(`${BASE}/api/vehicles/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  deleteVehicle: (id) =>
    fetch(`${BASE}/api/vehicles/${id}`, { method: 'DELETE', headers: headers() }).then(r => r.json()),

  // Photos
  uploadPhotos: (vehicleId, files) => {
    const fd = new FormData();
    files.forEach(f => fd.append('photos', f));
    return fetch(`${BASE}/api/photos/${vehicleId}`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: fd
    }).then(r => r.json());
  },

  deletePhoto: (photoId) =>
    fetch(`${BASE}/api/photos/${photoId}`, { method: 'DELETE', headers: headers() }).then(r => r.json()),

  // AI
  generateDescription: (data) =>
    fetch(`${BASE}/api/ai/description`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  bulkDescriptions: () =>
    fetch(`${BASE}/api/ai/bulk-descriptions`, { method: 'POST', headers: headers() }).then(r => r.json()),

  // Import
  previewCSV: (file) => {
    const fd = new FormData();
    fd.append('csv', file);
    return fetch(`${BASE}/api/import/preview`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: fd
    }).then(r => r.json());
  },

  importCSV: (file, mapping) => {
    const fd = new FormData();
    fd.append('csv', file);
    fd.append('mapping', JSON.stringify(mapping));
    return fetch(`${BASE}/api/import/csv`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: fd
    }).then(r => r.json());
  },

  // Customers
  getCustomers: () =>
    fetch(`${BASE}/api/customers`, { headers: headers() }).then(r => r.json()),

  getCustomer: (id) =>
    fetch(`${BASE}/api/customers/${id}`, { headers: headers() }).then(r => r.json()),

  saveCustomer: (data) =>
    fetch(`${BASE}/api/customers`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  updateCustomer: (id, data) =>
    fetch(`${BASE}/api/customers/${id}`, { method: 'PUT', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  deleteCustomer: (id) =>
    fetch(`${BASE}/api/customers/${id}`, { method: 'DELETE', headers: headers() }).then(r => r.json()),

  // Deals
  getDeals: () =>
    fetch(`${BASE}/api/deals`, { headers: headers() }).then(r => r.json()),

  getDeal: (id) =>
    fetch(`${BASE}/api/deals/${id}`, { headers: headers() }).then(r => r.json()),

  saveDeal: (data) =>
    fetch(`${BASE}/api/deals`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  recordPayment: (dealId, data) =>
    fetch(`${BASE}/api/deals/${dealId}/payment`, { method: 'POST', headers: headers(), body: JSON.stringify(data) }).then(r => r.json()),

  getUpcomingPayments: () =>
    fetch(`${BASE}/api/deals/payments/upcoming`, { headers: headers() }).then(r => r.json()),
};

export { getToken, getUser };
